import React, { useState, useEffect } from 'react';

import IntegrationSingle from '../Components/IntegrationSingle';

const services = [
  {
    id: 'phonecom',
    name: 'Phone.com',
    image: 'phonecomlogo.svg',
    imageHeight: '70px',
    databaseId: 5, // This should not be needed as the 'id' is sufficient but the API needs the database ID
    active: true,
    syncContacts: true,
    getPhoneNumbersExtensions: true,
    agencyAccount: true,
    type: 'oauth',
    htmlPrefix: (
      <>
        <div className="alert alert-secondary mb-4">
          <i className="fal fa-comment-exclamation mr-2"></i>MedicarePro users who sign up with
          Phone.com from the link below get Phone.com preferred support.
        </div>
      </>
    ),
    htmlInnerSuffix: (
      <>
        <br />
        <a href="https://www.phone.com/business-phone-systems/?_tracking_id=10758" target="_blank">
          <div className="btn btn-secondary mt-2">Preferred Support Sign-Up</div>
        </a>
        <div className="mt-3">
          Use code <b className="text-success">MEDICAREPROCRM</b> to get your first month free
        </div>
      </>
    ),
  },
  {
    id: 'dialpad',
    name: 'Dialpad',
    image: 'dialpad.png',
    imageHeight: '50px',
    active: true,
    type: 'oauth',
    syncContacts: true,
  },
  {
    id: 'ringcentral',
    name: 'Ring Central',
    image: 'ringcentral.png',
    imageHeight: '60px',
    databaseId: 2,
    active: true,
    type: 'oauth',
    getPhoneNumbersExtensions: true,
  },
  {
    id: 'openphone',
    name: 'OpenPhone',
    image: 'openphone.png',
    imageHeight: '120px',
    active: true,
    type: 'pat',
    external: true,
  },
  {
    id: 'goto',
    name: 'GoTo',
    image: 'gotologo.svg',
    imageHeight: '50px',
    databaseId: 4,
    active: true,
    type: 'oauth',
    getPhoneNumbersExtensions: true,
  },
  {
    id: 'simplii',
    name: 'Simplii',
    image: 'simplii.svg',
    imageHeight: '35px',
    active: true,
    type: 'custom',
    saveWebhookUrls: true,
    displayIncomingWebhookUrl: false,
    html: (
      <>
        <a
          className="btn  btn-primary mb-4 text-white"
          target="_blank"
          href="https://www.simplii.net"
        >
          Check them out
        </a>
      </>
    ),
  },
  {
    id: 'intulse',
    name: 'Intulse',
    image: 'intulse.png',
    imageHeight: '70px',
    active: true,
    type: 'pat',
    htmlPrefix: (
      <>
        <div className="alert alert-secondary mb-4">
          <i className="fal fa-comment-exclamation mr-2"></i>Generate a code here and share with
          Intulse so they can send us back your call logs.
        </div>
      </>
    ),
  },
  {
    id: 'intulse_external',
    name: 'Intulse - External',
    image: 'intulse.png',
    imageHeight: '70px',
    active: true,
    type: 'pat',
    external: true,
    htmlPrefix: (
      <>
        <div className="alert alert-secondary mb-4">
          <i className="fal fa-comment-exclamation mr-2"></i>Save code generated at Intulse to send
          SMS from the CRM.
        </div>
      </>
    ),
  },
  {
    id: 'talkdesk',
    name: 'TalkDesk',
    image: 'talkdesk.png',
    imageHeight: '120px',
    active: true,
    type: 'pat',
  },
  {
    id: 'convoso',
    name: 'Convoso',
    image: 'convoso2.png',
    imageHeight: '35px',
    active: true,
    type: 'pat',
  },
  {
    id: 'zoom',
    name: 'Zoom Phone',
    image: 'zoomLogo.png',
    imageHeight: '50px',
    active: true,
    type: 'oauth',
  },
  {
    id: 'dialedin',
    name: 'DialedIn',
    image: 'dialedin.png',
    imageHeight: '100px',
    active: true,
    type: 'pat',
  },
  {
    id: 'readymode',
    name: 'ReadyMode',
    image: 'readymode.png',
    imageHeight: '50px',
    active: true,
    type: 'custom',
    html: <>Reach out to your account manager at ReadyMode to enable this integration.</>,
    htmlPrefix: (
      <>
        <div className="alert alert-secondary mb-4">
          <i className="fal fa-comment-exclamation mr-2" aria-hidden="true"></i>Upload large lead
          lists to ReadyMode for super fast dialing, when you start talking to someone easily push
          their data from ReadyMode to MPCRM to make a new profile.
        </div>
      </>
    ),
  },
];

export default function AgentVoIPPhonePanel(props) {
  const allowedVoIPServices = props.allowedVoIPServices || [];

  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  var userRepository = new MedicareProAPI.UserRepository();
  userRepository.setAccessToken(props.userAccessToken);

  var userIntegrationOAuthRepository = new MedicareProAPI.UserIntegrationOAuthRepository();
  userIntegrationOAuthRepository.setAccessToken(props.userAccessToken);

  var agencyIntegrationOAuthRepository = new MedicareProAPI.AgencyIntegrationOAuthRepository();
  agencyIntegrationOAuthRepository.setAccessToken(props.userAccessToken);

  var userPersonalTokenRepository = new MedicareProAPI.UserPersonalTokenRepository();
  userPersonalTokenRepository.setAccessToken(props.userAccessToken);

  var userIntegrationOAuthVoipResourceRepository =
    new MedicareProAPI.UserIntegrationOAuthVoipResourceRepository();
  userIntegrationOAuthVoipResourceRepository.setAccessToken(props.userAccessToken);

  var userVoipExtensionRepository = new MedicareProAPI.UserVoipExtensionRepository();
  userVoipExtensionRepository.setAccessToken(props.userAccessToken);

  var userVoipPhoneNumberRepository = new MedicareProAPI.UserVoipPhoneNumberRepository();
  userVoipPhoneNumberRepository.setAccessToken(props.userAccessToken);

  var individualRepository = new MedicareProAPI.IndRepository();
  individualRepository.setAccessToken(props.userAccessToken);

  var individualAlternateIdRepository = new MedicareProAPI.IndAlternateIdRepository();
  individualAlternateIdRepository.setAccessToken(props.userAccessToken);

  const filteredServices =
    props?.allowedVoIPServices?.length > 0
      ? services.filter((service) => props.allowedVoIPServices.includes(service.id))
      : services;
  // Check which services are connected
  useEffect(() => {}, []);

  return (
    <>
      {filteredServices.map((service) => {
        return (
          <IntegrationSingle
            service={service}
            userId={props.userId}
            agencyId={props.agencyId}
            userAccessToken={props.userAccessToken}
            renderedExternal={props.renderedExternal}
          />
        );
      })}
    </>
  );
}
